if (!String.prototype.toFilterStartDate) {
    String.prototype.toFilterStartDate = function () {
        const parsedDate = new Date(this)
        if (isNaN(parsedDate.getTime())) {
            throw new Error(`Invalid date string: ${this}`)
        }
        parsedDate.setHours(0, 0, 0, 0)
        return parsedDate
    }
}

if (!String.prototype.toFilterEndDate) {
    String.prototype.toFilterEndDate = function () {
        const parsedDate = new Date(this)
        if (isNaN(parsedDate.getTime())) {
            throw new Error(`Invalid date string: ${this}`)
        }
        parsedDate.setHours(23, 59, 59, 999)
        return parsedDate
    }
}

if (!Date.prototype.toFilterEndDate) {
    Date.prototype.toFilterEndDate = function () {
        if (isNaN(this.getTime())) {
            throw new Error(`Invalid Date object: ${this}`)
        }
        const copy = new Date(this.getTime())
        copy.setHours(23, 59, 59, 999)
        return copy
    }
}
if (!String.prototype.toFilterStartDateTime) {
    String.prototype.toFilterStartDateTime = function (setDefaulttime = false) {
        const parsedDate = new Date(this)
        if (isNaN(parsedDate.getTime())) {
            throw new Error(`Invalid date string: ${this}`)
        }
        if (setDefaulttime) {
            console.log('setDefaulttime', setDefaulttime)
            parsedDate.setHours(0, 0, 0, 0)
        }

        return parsedDate
    }
}

const DateUtils = {
    getStartDate: (days) => {
        const today = new Date()
        const startingDate = new Date()
        startingDate.setDate(today.getDate() - (days || 7))
        startingDate.setHours(0, 0, 0, 0)
        return startingDate
    },

    getStartDateMonths: (months) => {
        const today = new Date()
        const startingDate = new Date(today)
        startingDate.setMonth(today.getMonth() - (months || 6))
        startingDate.setHours(0, 0, 0, 0)
        return startingDate
    },

    getEndDate: () => {
        const endingDate = new Date()
        endingDate.setHours(23, 59, 59, 999)
        return endingDate
    },

    getUtcStartDate: (days) => {
        const today = new Date()
        const startingDate = new Date(today)
        startingDate.setDate(today.getDate() - (days || 7))
        startingDate.setUTCHours(0, 0, 0, 0)
        return startingDate
    },

    getUtcEndDate: () => {
        const today = new Date()
        const endingDate = new Date(today)
        endingDate.setUTCHours(23, 59, 59, 999)
        return endingDate
    },
}

export default DateUtils
